import { useSuspenseQuery } from '@apollo/client';
import { JahrMonat } from '../entities';
import { TagebuchEintrag } from '../entities/tagebuchEintrag';
import { GET_TAGEBUCH_EINTRAEGE_BY_STANDORT_IDS } from './graphql/queries';
import { TemperaturEinheit } from '@/gql/graphql';
import { Wetter } from '../entities/wetter';
import * as Sentry from '@sentry/react';

export function useTagebuchEintraege({
  standortId,
  jahrMonat,
}: {
  jahrMonat: JahrMonat;
  standortId: string;
}): {
  tagebuchEintraege?: TagebuchEintrag[];
  error?: string;
} {
  const { data, error } = useSuspenseQuery(
    GET_TAGEBUCH_EINTRAEGE_BY_STANDORT_IDS,
    {
      variables: {
        jahr: jahrMonat.jahr,
        monat: jahrMonat.monat,
        standortIds: standortId,
        temperaturEinheit: TemperaturEinheit.C,
      },
    },
  );

  if (error) {
    Sentry.captureException(error);
    return { error: error?.message };
  }

  const dataByStandortId = data.controlling.find(
    (data) => data.standortId === standortId,
  );

  if (!dataByStandortId || dataByStandortId.tagebuchEintrag.length < 1) {
    return { tagebuchEintraege: [], error: 'Fehler beim laden der Daten.' };
  }

  const tagebuchEintraege = [];
  dataByStandortId.tagebuchEintrag.forEach((tagebuchEintrag) => {
    const mappedWetterArray = Array.isArray(tagebuchEintrag.wetter)
      ? tagebuchEintrag.wetter.map((wetter) => new Wetter(wetter))
      : [new Wetter(tagebuchEintrag.wetter)];

    const mappedTagebuchEintrag = new TagebuchEintrag({
      datum: tagebuchEintrag.datum,
      standortId: tagebuchEintrag.standortId,
      wetter: mappedWetterArray,
      interneNotiz: tagebuchEintrag.interneNotiz,
    });
    tagebuchEintraege.push(mappedTagebuchEintrag);
  });
  return { tagebuchEintraege };
}
